import React from 'react';
import { ErrorMessage, FormikValues } from 'formik';
import { ActionCheckbox } from '~/components/Patient/Gap/Actions';

interface QualityCheckRowProps {
    detail: QualityMeasureDetailType;
    checkboxId: string;
    readOnly: boolean;
    formik: FormikValues;
}
export function QualityCheckRow({ detail, checkboxId, readOnly, formik }: QualityCheckRowProps) {
    return (
        <>
            <tr
                className={`quality-gap-action-row gap-action-row ${
                    formik.errors[checkboxId] && formik.touched[checkboxId] ? 'text-danger' : ''
                }`}
            >
                <td className="checkbox-col" aria-label="Checkbox">
                    <div className="text-center">
                        <ActionCheckbox checkBoxId={checkboxId} readOnly={readOnly} />
                    </div>
                </td>
                <td className="w-25">
                    <label className="form-label" htmlFor={checkboxId}>
                        {detail.name}
                    </label>
                </td>
                <td>{detail.acceptable_date}</td>
                <td className="w-15">{detail.age_range}</td>
            </tr>
            {formik.errors[checkboxId] && (
                <tr className="quality-gap-action-row">
                    <td colSpan={4} aria-label="Error">
                        <div className="text-danger">
                            <ErrorMessage name={checkboxId} />
                        </div>
                    </td>
                </tr>
            )}
        </>
    );
}
